import { render, staticRenderFns } from "./UnidadesNuevas.vue?vue&type=template&id=b0e30552&"
import script from "./UnidadesNuevas.vue?vue&type=script&lang=js&"
export * from "./UnidadesNuevas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports